import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=58866938&"
import script from "./TimelineItem.vue?vue&type=script&lang=js&"
export * from "./TimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports